// extracted by mini-css-extract-plugin
export default {"deviceInfo":"DeviceName_deviceInfo__HXuRc"};